import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, vShow as _vShow, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22d56af2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tab-pane fade show active m-2 tab-content",
  id: "CurrentCensusTabContent",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_2 = {
  id: "censusTrendGraphContainer",
  class: "txtLeft"
}
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "facility", -1))
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "department", -1))
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "FROM", -1))
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "TO", -1))
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "PART OF DAY", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: -1,
  selected: ""
}, "All Templates...", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "CHART TYPE", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "col-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uppercase default-font-size" }, "FORECAST", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uppercase default-font-size" }, "ACTUAL", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uppercase default-font-size" }, "STAFF TO", -1))
const _hoisted_26 = {
  class: "col-2 search-wrapper",
  style: {"padding-top":"20px"}
}
const _hoisted_27 = { class: "activityLog-grid-container mt-2" }
const _hoisted_28 = {
  id: "census-trend-graph-loading",
  class: "text-center mt-3"
}
const _hoisted_29 = { class: "fa-2x" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_31 = {
  key: 0,
  style: {"margin-top":"20px"}
}
const _hoisted_32 = { style: {"font-size":"16px","color":"gray","font-family":"HCA-Mark, Arial, sans-serif","font-weight":"bold"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { id: "divLineChart" }
const _hoisted_36 = { id: "divColumnChart" }
const _hoisted_37 = { id: "divAreaChart" }
const _hoisted_38 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.selectedFacilities,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFacilities) = $event)),
                _ctx.onFacilityChange
              ],
              options: _ctx.facilities,
              searchable: true,
              "close-on-select": true,
              label: "Text",
              "track-by": "Text",
              placeholder: "All Facilities...",
              id: "selFacilities"
            }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.selectedDepartments,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDepartments) = $event)),
              options: _ctx.departments,
              searchable: true,
              "close-on-select": true,
              placeholder: "All Departments...",
              label: "Text",
              "track-by": "Text",
              id: "selDepartments"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.selectedStartDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedStartDate) = $event)),
              weekStart: "0",
              inputClassName: "dp-custom-input",
              class: "form-control requestDate",
              style: {"width":"100%"},
              enableTimePicker: true,
              autoApply: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.selectedEndDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedEndDate) = $event)),
              weekStart: "0",
              inputClassName: "dp-custom-input",
              class: "form-control requestDate",
              style: {"width":"100%"},
              enableTimePicker: true,
              autoApply: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("select", {
              class: "neu-select",
              name: "facility",
              id: "partOfDayDropdown",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedPartOfDay) = $event))
            }, [
              _hoisted_15,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partOfDays, (partOfDay) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: partOfDay.partOfDayId,
                  key: partOfDay.partOfDayId
                }, _toDisplayString(partOfDay.partOfDayName), 9, _hoisted_16))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedPartOfDay]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("select", {
              class: "neu-select",
              name: "chartType",
              id: "chartTypeDropdown",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedChartType) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartTypeArray, (objChartType) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: objChartType.ChartValue,
                  key: objChartType.ChartValue
                }, _toDisplayString(objChartType.ChartText), 9, _hoisted_19))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedChartType]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.chkForecastValue) = $event)),
              id: "chkForecast",
              name: "a11y-issues"
            }, null, 512), [
              [_vModelCheckbox, _ctx.chkForecastValue]
            ]),
            _hoisted_21,
            _hoisted_22,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.chkActualValue) = $event)),
              id: "chkActual",
              name: "a11y-issues"
            }, null, 512), [
              [_vModelCheckbox, _ctx.chkActualValue]
            ]),
            _hoisted_23,
            _hoisted_24,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.chkStaffToValue) = $event)),
              id: "chkStaffTo",
              name: "a11y-issues"
            }, null, 512), [
              [_vModelCheckbox, _ctx.chkStaffToValue]
            ]),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_neu_button, {
              type: "button",
              fill: "raised",
              id: "censusTrendSearch",
              class: "float-end me-1",
              onClick: _ctx.searchClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" SEARCH ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _withDirectives(_createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_font_awesome_icon, {
              spin: true,
              icon: ['fas', 'circle-notch'],
              size: "lg"
            })
          ]),
          _hoisted_30
        ], 512), [
          [_vShow, _ctx.isShowLoader]
        ]),
        (_ctx.censusGridData != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, [
                _createTextVNode(" Census Trend "),
                _hoisted_33,
                _createTextVNode(" Department (" + _toDisplayString(_ctx.CensusDataDepartmentName()) + ")", 1),
                (!_ctx.censusGridData.length)
                  ? (_openBlock(), _createElementBlock("br", _hoisted_34))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.censusGridData.length? '' : 'No Data Found'), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_35, null, 512), [
          [_vShow, _ctx.isShowLineChart]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_36, null, 512), [
          [_vShow, _ctx.isShowColumnChart]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_37, null, 512), [
          [_vShow, _ctx.isShowAreaChart]
        ])
      ])
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}